import { render } from "./RecommendedDonors.vue?vue&type=template&id=8834217a&scoped=true&ts=true"
import script from "./RecommendedDonors.vue?vue&type=script&lang=ts"
export * from "./RecommendedDonors.vue?vue&type=script&lang=ts"

import "./RecommendedDonors.vue?vue&type=style&index=0&id=8834217a&scoped=true&lang=css"
import "./RecommendedDonors.vue?vue&type=style&index=1&id=8834217a&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8834217a"]])

export default __exports__